<div fxLayout="column" fxLayoutAlign="space-between start">
  @if (!hideLabel) {
    <div class="forge-typography--heading1">{{label}}</div>
  }

  <div [fxLayout]="layout" role="radiogroup" [attr.aria-label]="groupLabel">
    @for (option of options; track option) {
      <forge-radio [value]="option" [formControl]="formControl" [name]="controlName" [id]="getOptionId(option)">
        @if (hasError('required')) {
          <span slot="helper-text">
            {{label}} is required
          </span>
        }
        <forge-tooltip>{{tooltip}}</forge-tooltip>
        {{ getDisplayValue(option) }}
      </forge-radio>
    }
  </div>
</div>